export const SUPPORTED_LOCALES = ['en', 'sv'];
export const DEFAULT_LOCALE = 'en';
